// src/liveStreamTos.js
// Live Stream Terms of Service & Acceptable Use
// NOT legal advice. Review with your broker and a Nevada real estate attorney 
// before opening to users.

export const LIVE_STREAM_TOS_VERSION = '1.0';
export const LIVE_STREAM_TOS_TYPE = 'live_stream';

export const LIVE_STREAM_TOS_TEXT = `
# Realty AI Live Stream — Terms of Use

**Effective:** ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
**Version:** ${LIVE_STREAM_TOS_VERSION}

By using Realty AI's Live Stream feature, you agree to the following terms. If you do not agree, do not use Live Stream.

## 1. Your Responsibility for Content

You are solely responsible for everything you broadcast through Realty AI's Live Stream feature, including video, audio, chat messages, and any materials you share on screen. Realty AI does not review or pre-approve content before it goes live.

## 2. Prohibited Content

You agree NOT to broadcast:

- False or misleading statements about any property, price, feature, or condition
- Content that violates Fair Housing laws, including statements that discriminate based on race, color, religion, national origin, sex, disability, or familial status
- Copyrighted material you don't have rights to (including music, video, images)
- Defamatory, harassing, threatening, or obscene content
- Personal information about third parties without their consent
- Content that violates any federal, state, or local law
- Content promoting illegal activity, fraud, or scams
- Sexually explicit content or content involving minors inappropriately

## 3. Real Estate Compliance

If you are a licensed real estate professional, you are responsible for complying with all applicable licensing laws, advertising regulations, and disclosure requirements in your jurisdiction. This includes but is not limited to NAR Code of Ethics, state real estate commission rules, and federal regulations such as the Fair Housing Act and RESPA.

If you are not a licensed real estate professional, you must not represent yourself as one or make representations that require a license.

## 4. Your Representations

You represent that:
- You are at least 18 years old
- You have the legal right to broadcast any property, person, or material you show
- Any information you provide about a property is accurate to your knowledge
- You have obtained any permissions required to record or broadcast

## 5. Third-Party Platforms

Realty AI's Live Stream may use third-party services (such as Restream) to facilitate broadcasting. Your use of those services is also subject to their terms. Realty AI is not responsible for outages, bans, or actions by those third parties.

## 6. No Warranty

The Live Stream feature is provided "as is" without warranties of any kind. Realty AI does not guarantee uptime, stream quality, audience reach, or that the service will be error-free.

## 7. Indemnification

You agree to defend, indemnify, and hold harmless Realty AI, its operators, and its affiliates from any claim, loss, damage, or expense (including legal fees) arising from:
- Content you broadcast
- Your violation of these terms
- Your violation of any law or third-party rights

## 8. Termination

Realty AI may suspend or terminate your access to Live Stream at any time, with or without notice, for any violation of these terms or for any other reason at Realty AI's discretion.

## 9. Limitation of Liability

To the fullest extent permitted by law, Realty AI's total liability to you for any claim arising from the Live Stream feature is limited to the amount you paid Realty AI in the 12 months before the claim.

## 10. Governing Law

These terms are governed by the laws of the State of Nevada. Any dispute will be resolved in the state or federal courts located in Clark County, Nevada.

## 11. Changes to These Terms

Realty AI may update these terms. Continued use of Live Stream after changes constitutes acceptance of the updated terms.

---

**By clicking "I Agree" below, you confirm that you have read and accept these Terms of Use and that you understand you are legally responsible for all content you broadcast.**
`;
